import React from 'react';

export const Sidebar = React.createContext(false);

export const SidebarDispatch = React.createContext(() => {});
